import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined'
import React, { useState } from 'react'
import { useAuth } from '../../applications/hooks/UseAuth'
import ToolbarButton from '../../components/DataTable/ToolbarButton'
import PageHeader from '../../components/Typography/PageHeader'
import CalibrationForm from './components/CalibrationForm'
import CalibraitonList from './components/CalibrationList'
import CalibrationService from './services/CalibrationService'
// import RolesList from '../users/components/roles/RoleList'

const Calibration = () => {
    const { haveAccessTo } = useAuth()
    const [needLoad, setNeedLoad] = useState(true)
    const useDrawer = false
    const service = CalibrationService.load()

    const CURRENT_PAGE = 'administration_roles'

    return (
        <div className={'card w-full bg-base-100'} style={{ paddingBottom: 20 }}>
            <PageHeader
                title={'Gestion des Etallonages'}
                subTitle={'Gestion des Etallonages'}
                icon={<LockPersonOutlinedIcon color="primary" fontSize="large" />}
            >
                {' '}
                <ToolbarButton
                    moduleTitle="Etallonages"
                    service={service}
                    drawer={useDrawer}
                    haveAccessTo={haveAccessTo}
                    currentPage={CURRENT_PAGE}
                    setNeedLoad={setNeedLoad}
                    needLoad={needLoad}
                    Form={CalibrationForm}
                />
            </PageHeader>
            <CalibraitonList
                service={service}
                drawer={useDrawer}
                Form={CalibrationForm}
                haveAccessTo={haveAccessTo}
                currentPage={CURRENT_PAGE}
                setNeedLoad={setNeedLoad}
                needLoad={needLoad}
            />
        </div>
    )
}

export default Calibration;